import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { SerialNoCellComponent } from '../../../table-cell/serial-no-cell.component';
import { KeywordSearchService } from '../../../services/raintree/Transmission/keyword-search.service';
import {
  KeywordSearchRequest,
  KeywordSearchRespo,
} from '../../../services/raintree/interfaces/keyword-search';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { DistrictListService } from '../../../services/raintree/Transmission/district-list.service';
import { SatesListService } from '../../../services/raintree/Transmission/sates-list.service';
import { SerialNoUpdateCellComponent } from '../../../table-cell/serial-no-update-cell.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DpLoaderComponent } from "../../../common-component/dp-loader/dp-loader.component";
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'keyword-search-tab',
  standalone: true,
  templateUrl: './keyword-search-tab.component.html',
  styleUrls: [
    './keyword-search-tab.component.scss',
    '../../../../styles/_dropdown.scss',
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    DpTableComponent,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    InfiniteScrollModule,
    DpLoaderComponent
],
})
export class KeywordSearchTabComponent implements OnInit {
  responseData: any = [];
  districtList: any = [];
  stateList: any = [];
  isLoader: boolean = false;
  public pageNo = 1;
  public pageSize = 200;
  numberOfLoaders=20;
  noDataFound: boolean=false;

  keywordSearchForm = new FormGroup({
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    guardianFirstName: new FormControl(''),
    guardianMiddleName: new FormControl(''),
    guardianLastName: new FormControl(''),
    ritwikFirstName: new FormControl(''),
    ritwikMiddleName: new FormControl(''),
    ritwikLastName: new FormControl(''),
    initiationDate: new FormControl(''),
    districtName: new FormControl(''),
    stateName: new FormControl(''),
    address: new FormControl(''),
    pincode: new FormControl(''),
    pageNo: new FormControl(1),
    pageSize: new FormControl(200),
  });
  @Output() serialNo: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private _keywordSearchService: KeywordSearchService,
    private _districtService: DistrictListService,
    private _stateService: SatesListService
  ) {}

  ngOnInit(): void {
    this.keywordSearchForm.get('stateName')?.setValue('');
    this.keywordSearchForm.get('districtName')?.setValue('');
    this.getStatesDistrictList();
  }
  public displayColumnData: any = [
    {
      id: 'mk',
      name: 'Sl No.',
    },
    {
      id: 'rs',
      name: 'Mem Status',
    },
    {
      id: 'dn',
      name: 'District',
    },
    {
      id: 'fullName',
      name: 'Name',
    },
    {
      id: 'guardianName',
      name: 'Guardian',
    },
    {
      id: 'md',
      name: 'Initiation Date',
    },
    {
      id: 'rn',
      name: 'Ritwik',
    },
    {
      id: 'pn',
      name: 'Pincode',
    },
    {
      id: 'add',
      name: 'Address',
    },
  ];

  columnConfs = {
    memberStatus: { cssClass: 'memberStatuswidth' },
    pincode: { cssClass: 'pincodewidth' },
  };

  cellComponentMap = {
    mk: SerialNoUpdateCellComponent,
  };

  getFormValue(controlName: string): any {
    return this.keywordSearchForm.get(controlName)?.value;
  }

  clearStateSelection(event: Event) {
    this.districtList = [];
    event.stopPropagation();
    this.keywordSearchForm.get('stateName')?.setValue('');
    this.keywordSearchForm.get('districtName')?.setValue('');
  }

  clearDistrictSelection(event: Event) {
    event.stopPropagation();
    this.keywordSearchForm.get('districtName')?.setValue('');
  }
  onKeywordSearch(isStart: boolean) {
    if (isStart) {
      this.responseData = [];
      this.pageNo = 1;
      this.isLoader = true;
    } else {
      this.pageNo += 1;
    }

    this.keywordSearchForm.controls['pageNo'].setValue(this.pageNo);
    this.keywordSearchForm.controls['pageSize'].setValue(this.pageSize);

    let keywordSearchObj: KeywordSearchRequest = {
      state_name:
        this.getFormValue('stateName') === 'default'
          ? ''
          : this.getFormValue('stateName'),
      district_name:
        this.getFormValue('districtName') === 'default'
          ? ''
          : this.getFormValue('districtName'),
      firstName: this.getFormValue('firstName'),
      lastName: this.getFormValue('lastName'),
      middleName: this.getFormValue('middleName'),
      guardian_first_name: this.getFormValue('guardianFirstName'),
      guardian_middle_name: this.getFormValue('guardianMiddleName'),
      guardian_last_name: this.getFormValue('guardianLastName'),
      rc:this.getFormValue('rc'),
      ritwiki_first_name: this.getFormValue('ritwikFirstName'),
      ritwiki_middle_name: this.getFormValue('ritwikMiddleName'),
      ritwiki_last_name: this.getFormValue('ritwikLastName'),
      mship_date: this.getFormValue('initiationDate'),
      pinCode: this.getFormValue('pincode'),
      address: this.getFormValue('address'),
      pageNo: this.getFormValue('pageNo'),
      pageSize: this.getFormValue('pageSize'),
    };

    this._keywordSearchService.getSearchData(keywordSearchObj).subscribe({
      next: (response: KeywordSearchRespo) => {
        this.isLoader = false;
        this.noDataFound = false;

        if (response?.data?.memberList.length == 0) {
          this.isLoader = false;
          if(isStart){
            this.noDataFound=true;
          }
        }
        else if(response.data){
          this.responseData = [...this.responseData,...response?.data?.memberList.map(
            (item: { gfn: string; gln: string; fn: string; ln: string }) => ({
              ...item,
              fullName: item.fn + ' ' + item.ln,
              guardianName: item.gfn + ' ' + item.gln,
              rs: 'FW Pending',
            })
          )];
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getStatesDistrictList() {
    this._stateService.getStatesList().subscribe({
      next: (response: any) => {
        if (!response.error) {
          let resp = response.data;

          resp.forEach((elm: any) => {
            this.stateList.push(elm);
          });
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getDistrictList(event: any) {
    this.keywordSearchForm.get('districtName')?.setValue('');
    this._districtService.getDistrictList(event.value).subscribe({
      next: (response: any) => {
        if (!response.error) {
          this.districtList = [];
          let resp = response.data;

          resp.forEach((elm: any) => {
            this.districtList.push(elm);
          });
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  onCellClick(event: any) {
    this.serialNo.emit(event);
  }

  clearEntries(){
    this.responseData = [];
  }
}
